import axios from 'axios';
import { DOCUMENT_URL_ENDPOINT, DOCUMENTS_ENDPOINT } from '../constants/endpoint';

const GetDocuments = async (contractId, proposalId, sowId) => {
  const response = await axios.get(`${DOCUMENTS_ENDPOINT}?contractId=${contractId}&proposalIdentifier=${proposalId}${sowId ? `&sowId=${sowId}` : ''}`);
  return response;
};

const GetDocumentURL = async (S3Path, documentType, id) => {
  const response = await axios.get(`${DOCUMENT_URL_ENDPOINT}/${id}?documentType=${documentType}&S3Path=${S3Path}`);
  return response;
};

export { GetDocuments, GetDocumentURL };
